import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({server: 'camara', endPoint: `comprobar_camara?t=${Date.now()}`, method: 'GET', body: null, mode: 'cors', credentials: 'omit'})
}
